import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import { Tooltip } from 'antd'
import { IconSpy } from '../../../../shared/components/icons/IconSpy'
import { IconShopping } from '../../../../shared/components/icons/IconShopping'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CustomTag, TagsEditor } from '../../../../lib/widgets/tags-editor/TagsEditor'
import { useAppDispatch, useAppSelector } from '../../../../app/store/hooks/Redux'
import { AdvertiserReportFilterInterface } from '../../model/types/AdvertiserReportFilter.interface'
import {
  selectAdvertiserReportFilters,
  setAdvertiserReportFilter,
} from '../../model/paidResultsSlice'
import { useSearchParams } from 'react-router-dom'
import enhancedApi from '../../../../app/api'

interface AdvertiserCellProps {
  project: string
  advertiser: string
  is_decloak?: boolean
  tags: string[]
  last_url?: string
  shopping_ads: any[]
}

export const DomainCell = ({
  project,
  advertiser,
  is_decloak,
  tags,
  last_url,
  shopping_ads,
}: AdvertiserCellProps) => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const filters = useAppSelector<AdvertiserReportFilterInterface>(selectAdvertiserReportFilters)
  const dispatch = useAppDispatch()

  const handleDelete = (deletedTag: CustomTag) => {
    if (filters.tags?.split(',').includes(String(deletedTag.id))) {
      const filteredTags = filters.tags
        ?.split(',')
        .filter((tag) => tag !== String(deletedTag.id))
        .join(',')

      dispatch(
        setAdvertiserReportFilter({
          ...filters,
          tags: filteredTags,
        }),
      )

      setSearchParams((searchParams) => {
        filteredTags ? searchParams.set('tags', filteredTags) : searchParams.delete('tags')

        return searchParams
      })
    }
  }

  const handleUnassign = (id: number) => {
    if (filters.tags?.split(',').includes(String(id))) {
      dispatch(enhancedApi.util.invalidateTags(['AdvertiserReport']))
    }
  }

  return (
    <div>
      <div className={'flex items-center justify-start gap-[8px]'}>
        <BpAnchor className='w-fit' href={last_url || `https://${advertiser}`} target='_blank'>
          {advertiser}
        </BpAnchor>
        <div className={'flex items-center justify-start'}>
          {is_decloak && (
            <Tooltip
              arrowPointAtCenter
              placement='topLeft'
              title={t('pages.paidResults.decloakTooltip')}
            >
              <div className='ml-[12px] inline-block w-[22px]'>
                <IconSpy color='#00326D' />
              </div>
            </Tooltip>
          )}
          {shopping_ads?.length > 0 && (
            <Tooltip
              arrowPointAtCenter
              placement='topLeft'
              title={t('pages.paidResults.shoppingAdsTooltip')}
            >
              <div className='ml-[12px] inline-block w-[22px]'>
                <IconShopping color='#00326D' />
              </div>
            </Tooltip>
          )}
        </div>
      </div>
      <div className={'pt-[2px]'}>
        <TagsEditor
          domain={advertiser}
          project={project}
          tags={tags}
          onDelete={handleDelete}
          onUnassign={handleUnassign}
        />
      </div>
    </div>
  )
}
